import axios from "axios"
import { setError, setLoading, setSummary } from "../slices/dashboard"

export const fetchDashboardSummary = (dateFrom, dateTo, forceReviews) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const params = {}
    if (dateFrom) params.dateFrom = dateFrom
    if (dateTo) params.dateTo = dateTo
    if (forceReviews) params.forceReviews = true

    const { data } = await axios.get("/api/dashboard/summary", { params })
    dispatch(setSummary(data))
    return data
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading dashboard data. Please try again later"
      )
    );
  }
}
